<template>
  <UserEmailColumn :row="member.user" :row-index="rowIndex" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import UserEmailColumn from '@/components/GraphqlDataTable/columns/User/UserEmailColumn.vue'

const TeamMemberEmailColumn = graphql(`
  fragment TeamMemberEmailColumn on CompanyTeamMember {
    id
    user {
      id
      ...UserEmailColumn
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof TeamMemberEmailColumn>
  rowIndex?: number
}>()

const member = computed(() => useFragment(TeamMemberEmailColumn, props.row))
</script>
